import {OrganizationType, SystemRole} from "#generated"
import type {AuthorizationSilo} from "#auth/types"

export const authorizationContext = (
    silo?: AuthorizationSilo | null,
    user?: {
        isStaff: boolean
        isSuperuser: boolean
        role?: SystemRole | null
        memberships: {organization: {id: string; type?: OrganizationType | null}}[]
    } | null,
): {
    isStaff: boolean
    isSuperuser: boolean
    isEnterpriseCloud: boolean
    ownOrganizationIds: string[]
} => {
    if (silo) {
        return {
            isStaff: silo.systemRole === SystemRole.Staff || silo.systemRole === SystemRole.Superadmin,
            isSuperuser: silo.systemRole === SystemRole.Superadmin,
            // Kept type-based: self-service orgs share the EnterpriseCloud type today. Whether they
            // should lose EC-level abilities is a separate decision (see accountType follow-ups).
            isEnterpriseCloud: silo.organization?.type === OrganizationType.EnterpriseCloud,
            ownOrganizationIds: silo.organization?.id ? [silo.organization.id] : [],
        }
    } else if (user) {
        return {
            isStaff: user.role === SystemRole.Staff || user.role === SystemRole.Superadmin,
            isSuperuser: user.role === SystemRole.Superadmin,
            isEnterpriseCloud: user.memberships.some((membership) => membership.organization?.type === OrganizationType.EnterpriseCloud),
            ownOrganizationIds: user.memberships.map((membership) => membership.organization.id) ?? [],
        }
    } else {
        return {isStaff: false, isSuperuser: false, isEnterpriseCloud: false, ownOrganizationIds: []}
    }
}
